module.exports = __webpack_public_path__ + "static/media/new_law_icon_grey.7fe0f8e5.svg";